export default __webpack_public_path__ + "static/media/landscape25.81186576.JPG";